import { io } from 'socket.io-client';

export const socket = io(import.meta.env.VITE_SOCKET_URL, {
	extraHeaders: {},
	path: import.meta.env.VITE_SOCKET_PATH,
	withCredentials: true,
	autoConnect: false,
	transports: ['websocket'],
	reconnection: true,
	reconnectionAttempts: Infinity,
	reconnectionDelay: 1000,
	reconnectionDelayMax: 10000,
});
